import { useTranslation } from "react-i18next";
import CompetitorCard from "../../competitorAnalysisCard";

export const UrlCompetitorAnalysis = ({ competitorResults }) => {
  const { t } = useTranslation();
  return (
    <>
      {competitorResults && competitorResults?.analysis?.length > 0 && (
        <>
          <p className="text-white text-xl mt-6 mb-4 font-bold">
            {t("Competition", "Competition")}
          </p>
        </>
      )}
      {competitorResults &&
        competitorResults?.analysis?.map((item, index) => {
          return (
            <CompetitorCard
              type={"slug"}
              general={competitorResults.general}
              index={index}
              content={competitorResults.contents[index]}
              analysis={item}
              seoRequest={competitorResults.seo_request}
              url={competitorResults.contents[index].url}
            ></CompetitorCard>
          );
        })}
    </>
  );
};
